
import { useState } from "react";
import { EditPropertyTabs } from "@/components/properties/edit/EditPropertyTabs";
import { useEditProperty } from "@/hooks/useEditProperty";

const EditPropertyPage = () => {
  const [activeTab, setActiveTab] = useState("details");
  const editPropertyData = useEditProperty();
  
  const { 
    property, 
    propertyImages, 
    isFetching, 
    fetchPropertyData 
  } = editPropertyData;
  
  if (isFetching) {
    return (
      <div className="space-y-6 pb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Loading...</h1>
          </div>
        </div>
      </div>
    );
  }
  
  return (
    <div className="space-y-6 pb-8 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Edit Property</h1>
        <p className="text-muted-foreground">{property.address}, {property.city}, {property.state}</p>
      </div>
      
      <EditPropertyTabs
        activeTab={activeTab}
        onTabChange={setActiveTab}
        propertyData={editPropertyData}
        propertyImages={propertyImages}
        onImagesUpdated={fetchPropertyData}
      />
    </div>
  );
};

export default EditPropertyPage;
